import bankRipley from '../../banksPNG/bankRipley.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoRipleyIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Ripley',
}: IconProps) => <img src={bankRipley} width={width} height={height} alt={alt} />;
